export default __webpack_public_path__ + "static/media/Invasions.b1dfc788.gif";